import { useState } from "react";
import { makeAdultQuiz, makeOtherAdultQuiz, adultGateOk, type AdultQuiz } from "@greg-chick/shared";

/**
 * 🔢 **어른 확인** — 두 자리 곱셈. 0~7세가 암산으로 못 하고 어른은 2~3초면 한다.
 *
 * ## 🔴 통과를 저장하지 않는다
 * 한 번 통과하면 **그 화면이 열려 있는 동안만** 유효하다. 저장하면 아이가 나중에 혼자
 * 열 수 있고, 그러면 이 문을 만든 이유가 없어진다. 저장할 곳도 없다 — 무수집(불변식 1).
 *
 * ## 🔴 판정은 `shared` 한 곳
 * 문제를 만드는 것(`makeAdultQuiz`)도 맞는지 보는 것(`adultGateOk`)도 `packages/shared` 에
 * 있다. 자유 대화 문(`NpcChat`)과 **같은 함수**를 쓴다 — 화면마다 다시 짜면 한쪽만 느슨해진다.
 *
 * 틀리면 **새 문제로 바꾼다**. 같은 문제를 계속 찍어 맞히지 못하게.
 */
export function AdultGate({ what, onPass }: { what: string; onPass: () => void }) {
  const [quiz, setQuiz] = useState<AdultQuiz>(() => makeAdultQuiz());
  const [input, setInput] = useState("");
  const [wrong, setWrong] = useState(false);

  function submit(e: React.FormEvent) {
    e.preventDefault();
    if (adultGateOk(quiz, input)) {
      onPass();
      return;
    }
    setWrong(true);
    setInput("");
    setQuiz(makeOtherAdultQuiz(quiz));
  }

  return (
    <form className="adultgate" onSubmit={submit}>
      <p className="adultgate__why">
        여기는 <b>{what}</b> 자리예요. 어른이 맞는지 확인할게요.
      </p>
      <p className="adultgate__quiz" aria-live="polite">
        {quiz.text}
      </p>
      <label className="adultgate__label">
        <span className="sr-only">답</span>
        <input
          className="adultgate__input"
          type="text"
          inputMode="numeric"
          autoComplete="off"
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
            setWrong(false);
          }}
          aria-label="답"
          aria-invalid={wrong}
        />
      </label>
      <button className="btn adultgate__go" type="submit" disabled={!input.trim()}>
        확인
      </button>
      {/* 🔴 「틀렸다」만 말하지 않는다 — 어른이 오타를 냈을 수도 있어 다시 하라고 말한다 */}
      {wrong ? (
        <p className="adultgate__wrong" role="status">
          답이 달라요. 새 문제로 다시 해 주세요.
        </p>
      ) : null}
    </form>
  );
}
